<template>
  <side-panel-inner :headerTitle="headerTitle">
    <template slot="actions" v-if="!loading">
      <base-button :primary="true" @click="onGroupCreate">Save</base-button>
    </template>
    <loading v-if="loading" />
    <div v-else>
      <message type="error" v-if="displayError">
        <p>
          <strong>There was a problem with the form</strong>
        </p>

        <ul v-if="errors">
          <li v-for="error in errors.items" :key="error.id">{{ error.msg }}</li>
        </ul>
      </message>

      <form-field
        label="Name your group"
        full-width
        required
        name="name"
        v-validate="'required'"
        data-vv-as="group name"
        v-model="group.name"
        :error="errors.first('name')"
      />
      <form-field
        label="Give your group a description"
        type="textarea"
        full-width
        required
        v-model="group.description"
        :error="errors.first('description')"
        name="description"
        v-validate="'required'"
        data-vv-as="group description"
      />
      <form-field
        label="Groups members"
        helperText="Select the users you want to be part of this group"
        full-width
        required
      >
        <user-select
          :users="users"
          v-model="selectedUsers"
          id="users"
          name="users"
          v-validate="{ required: true }"
          data-vv-as="group members"
          :error="errors.first('users')"
          multiple
          @input="onUserAdd"
        />
      </form-field>
    </div>
  </side-panel-inner>
</template>

<script>
import { mapState } from "vuex";
const UserSelect = () => import("@/components/UserSelect");
export default {
  name: "UserGroupAddEdit",
  components: { UserSelect },
  data() {
    return {
      loading: true,
      editMode: false,
      displayError: false,
    };
  },
  computed: {
    ...mapState("UserGroups", ["group"]),
    ...mapState({
      users: (state) => state.users.collection,
    }),
    headerTitle() {
      return this.editMode ? "Edit Group" : "Create Group";
    },
    selectedUsers() {
      return this.group.users
    },
  },
  created() {
    if (this.$route.params.groupId) {
      this.$store
        .dispatch("UserGroups/read", this.$route.params.groupId)
        .then((resp) => {
          this.loading = false;
          this.editMode = true;
        })
        .catch((err) => {
          this.loading = false;
          this.editMode = true;
        });
      //load group
    } else {
      this.loading = false;
    }
  },
  methods: {
    onGroupCreate() {
      this.$validator.validate().then((result) => {
        if (!result) {
          this.displayError = true;
        } else {
          this.displayError = false;
          const action = this.editMode
            ? "UserGroups/edit"
            : "UserGroups/create";
          // If we are editing and the users haven't been touched, convert here
          if (this.group.users[0].id) {
            this.group.users = this.group.users.map((usr) => usr.id);
          }
          this.$store
            .dispatch(action, this.group)
            .then((resp) => {
              this.$store.dispatch(
                "notifications/create",
                {
                  body: `Your user group was ${
                    this.editMode ? "updated" : "created"
                  }`,
                  type: "success",
                },
                { root: true }
              );
              this.$store.dispatch("CLOSE_PANEL");
            })

            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    onUserAdd(val) {
      this.group.users = val;
    },
  },
};
</script>

<style scoped></style>
